import { Breadcrumbs } from "AbstractElements"
import TestimonyProgramContain from "Component/Learning/TestimonyProgram"

const TestimonyProgramList = () => {
  return (
    <>
      <Breadcrumbs title="Testimoni Program" />
      <TestimonyProgramContain />
    </>
  )
}

export default TestimonyProgramList